import React from 'react';
import {connect} from 'react-redux';
import {Trans} from 'react-i18next';
import CollaboratorItem from './components/collaborator-item/index';
import {
	getChangedStatus, ownershipChangeTarget
} from '../../../../../../../../../../../../../actions/sharingDetailsActions';
import Loader from '../../../../../../../../../../../../components/sprite/components/loader/index';
import CollaboratorsGroupDetails from './components/collaborators-group-details/index';
import LockedSharingReason from './components/locked-sharing-reason/index';
import {isEmptyObj, APP_URL} from '../../../../../../../../../../../../utils/index';
import HiddenFieldsList from './components/hidden-fields-list';
import CollaboratorDetails from './components/collaborator-details';
import './index.css';

class ListOfCollaboratorsContent extends React.Component {

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.updateCollaborators.length !== this.props.updateCollaborators.length){
			if(this.props.updateCollaborators.length > 0){
				this.props.setChangedStatus(true);
			} else {
				this.props.setChangedStatus(false);
			}
		}
	}

	displayCollaborators(){
		if(this.props.findCollaborators !== null){
			if(!isEmptyObj(this.props.findCollaborators)){
				if(this.props.enteredCollaboratorSearchValue !== "") {
					return this.props.findCollaborators.collaborators.map((collaborator, index) => {
						if(collaborator.name.toLowerCase().includes(this.props.enteredCollaboratorSearchValue.toLowerCase())){
							return (
								<CollaboratorItem
									key={this.props.selectedContactsGroup.id+collaborator.id}
									id={collaborator.id}
									groupId={collaborator.groupId}
									index={index}
									avatar={`${APP_URL}/account/avatar/${collaborator.id}`}
									name={collaborator.name}
									email={collaborator.email}
									statuses={collaborator.statuses}
									syncopt={collaborator.addToContact}
									permission={collaborator.permission}
									type={collaborator.type}
									userRole={collaborator.userRole}
									isOwner={this.props.profile.id === collaborator.id && collaborator.permission === 'OWNER'}
									internal={collaborator.internal}
									hiddenFields={collaborator?.hiddenFields}
								/>
							)
						} else {
							return null
						}
					});
				} else {
					return this.props.findCollaborators.collaborators.map((collaborator, index) => (
						<CollaboratorItem
							key={this.props.selectedContactsGroup.id+collaborator.id}
							id={collaborator.id}
							groupId={collaborator.groupId}
							index={index}
							avatar={`${APP_URL}/account/avatar/${collaborator.id}`}
							name={collaborator.name}
							email={collaborator.email}
							statuses={collaborator.statuses}
							syncopt={collaborator.addToContact}
							permission={collaborator.permission}
							type={collaborator.type}
							userRole={collaborator.userRole}
							isOwner={this.props.profile ? this.props.profile.id === collaborator.id && collaborator.permission === 'OWNER' : this.props.setGmailAddOnData.userId === collaborator.id && collaborator.permission === 'OWNER'}
							internal={collaborator.internal}
							hiddenFields={collaborator?.hiddenFields}
						/>
					));
				}
			} else {
				return "¯\\_(ツ)_/¯"
			}
		} else {
			return <Loader/>
		}
	}

    render() {

		if(this.props.profile){
			return (
				<div className={`list-of-collaborators-details-content container-fluid p-0${this.props.profile.domain.status === "EXPIRED_EVAL" ? ' locked' : ''}`}>
					{this.props.profile.domain.status === "EXPIRED_EVAL"
						?
						<LockedSharingReason type="expired_licenses"/>
						:
						''
					}
					{
						this.props.selectedCollaborator !== null
						?
							this.props.selectedCollaborator.type === "group"
							?
								this.props.showHiddenFields ?
									<div>
										<CollaboratorDetails collaborator={this.props.selectedCollaborator}/>
										<HiddenFieldsList hiddenFields={this.props.selectedCollaborator.hiddenFields}/>
									</div>
								:
									<CollaboratorsGroupDetails id={this.props.selectedCollaborator.id}/>
							:
								this.props.showHiddenFields
								?
									<div>
										<CollaboratorDetails collaborator={this.props.selectedCollaborator}/>
										<HiddenFieldsList hiddenFields={this.props.selectedCollaborator.hiddenFields}/>
									</div>
								:
									<div className={`collaborators`}>
										{
											this.displayCollaborators()
										}
									</div>
						:
							<div className={`collaborators`}>
								{
									this.displayCollaborators()
								}
							</div>
					}
				</div>
			)
		} else if (this.props.setGmailAddOnData) {

			/*
			* Gmail addon
			* */

			return (
				<div className={`list-of-collaborators-details-content container-fluid p-0${this.props.setGmailAddOnData.status === "EXPIRED_EVAL" ? ' locked' : ''}`}>
					{this.props.setGmailAddOnData.status === "EXPIRED_EVAL"
						?
						<LockedSharingReason type="expired_licenses"/>
						:
						''
					}
					{
						this.props.selectedCollaborator !== null
							?
							<CollaboratorsGroupDetails id={this.props.selectedCollaborator.id}/>
							:
							<div className={`collaborators`}>
								{
									this.displayCollaborators()
								}
							</div>
					}
				</div>
			)
		} else {
			return (
				<div>
					<div className="alert alert-danger mt-4">
						<Trans i18nKey="textRegisterPopup3" components={{a: <a href={`${APP_URL}/support`}> </a>}} />
					</div>
				</div>
			)
		}
    }
}

const mapStateToProps = (state) => {
	return {
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		findCollaborators: state.sharingDetailsReducer.findCollaborators,
		enteredCollaboratorSearchValue: state.sharingDetailsReducer.enteredCollaboratorSearchValue,
        collaboratorsPageNumber: state.sharingDetailsReducer.collaboratorsPageNumber,
		collaboratorsPageSize: state.sharingDetailsReducer.collaboratorsPageSize,
		selectedCollaborator: state.sharingDetailsReducer.selectedCollaborator,
		sharedWithMeDisplayMode: state.sharingDetailsReducer.sharedWithMeDisplayMode,
		showHiddenFields: state.sharingDetailsReducer.showHiddenFields,
		profile: state.profileReducer.getProfile,
		setGmailAddOnData:state.profileReducer.setGmailAddOnData,
		updateCollaborators: state.sharingDetailsReducer.updateCollaborators
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setOwnershipChangeTarget : (boolean) => {
			dispatch(ownershipChangeTarget(boolean))
		},
		setChangedStatus : (boolean) => {
			dispatch(getChangedStatus(boolean))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(ListOfCollaboratorsContent)
